export default __webpack_public_path__ + "static/media/Vitejs-logo.svg.d29a24dc.png";